import { Container, Grid, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import QCLogo from '../../../images/qc-city-logo.svg';
import BPLDLogo from '../../../images/bpld-logo.png';

class Header extends Component {
    render() {
        return (
            <div id="header__wrapper">
                <Container>
                    <Grid container direction="row">
                        <Grid item xs={3} md={3} lg={3}>
                            <div className="header__img">
                                <img src={QCLogo} alt="" />
                            </div>
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <div className="header__text--container">
                                <Typography component="h1" variant="h5">Republic of the Philippines</Typography>
                                <Typography component="h1" variant="h4">Quezon City</Typography>
                                <Typography component="h1" variant="h5">Business Permits and Licensing Department</Typography>
                                
                            </div>
                        </Grid>
                        <Grid item xs={3} md={3} lg={3}>
                            <div className="header__img float-right">
                                <img src={BPLDLogo} alt="" />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        )
    }
}

export default Header;






